import Axios from 'axios';

export class APIClient {

  static baseURL = 'https://open-apostille-backend.herokuapp.com/api/v2';
  // static baseURL = 'http://localhost:3000/api/v2';

  static async getApostilles() {
    try {
      const res = await Axios.get(`${this.baseURL}/apostilles`);
      return res.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  static async getApostillesByAddress(address: string) {
    try {
      const res = await Axios.get(`${this.baseURL}/owner/${address}`);
      return res.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  static async getApostilleByTxHash(txHash: string) {
    try {
      const res = await Axios.get(`${this.baseURL}/apostille/${txHash}`);
      return res.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  static async uploadApostille(encodedData: string, deleteKey: string, filename: string) {
    try {
      const res = await Axios.post(`${this.baseURL}/add/from-wallet`, {
        encodedData: encodedData,
        deleteKey: deleteKey,
        filename: filename
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  static async uploadApostilleFromFast(encodedData: string, deleteKey: string, filename: string, txHash: string, tag: string) {
    try {
      const res = await Axios.post(`${this.baseURL}/add/from-fast`, {
        encodedData: encodedData,
        deleteKey: deleteKey,
        filename: filename,
        txHash: txHash,
        tag: tag,
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  static async deleteApostille(txHash: string, deleteKey: string) {
    try {
      const res = await Axios.post(`${this.baseURL}/delete`, {
        txHash: txHash,
        deleteKey: deleteKey,
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  static async getNamespaces(address: string) {
    try {
      const res = await Axios.get(`${this.baseURL}/namespace/${address}`);
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
}
